// @ts-nocheck
import UserPlus from "@insite/mobius/Icons/UserPlus";
import { Icon, Typography } from "@insite/mobius/index";
import getColor from "@insite/mobius/utilities/getColor";
import { ButtonRow } from "@store/Library/Components/Bunzl/Common/EditItemListButton";
import UserPen from "@store/Library/Components/Icons/UserPen";
import colors from "@store/Themes/common/styleguide/config/colors";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface EditUsersListButtonProps {
    onClick: () => void;
    numberOfUsers: number | string;
}
const EditUsersListButton: React.FC<EditUsersListButtonProps> = ({ onClick, numberOfUsers }) => {
    const [isHovering, setIsHovering] = React.useState(false);
    return (
        <ButtonRow onClick={onClick} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
            <Typography
                css={css`
                    font-size: ${pxToRem(20)};
                    font-weight: 600;
                    color: ${isHovering ? getColor("secondary") : getColor("primary")};
                `}
            >
                {numberOfUsers}
            </Typography>
            <Icon color={isHovering ? colors?.secondary?.main : colors?.primary?.main} size={24} src={UserPen} />
        </ButtonRow>
    );
};

export default EditUsersListButton;
